import Auth from './auth';
import Suggestions from './suggestions';
import Imports from './imports';

export default class ServerClient {
  auth: Auth;

  suggestions: Suggestions;

  imports: Imports;

  headers: Record<string, string> | undefined;

  constructor(host: string, auth: string, headers: Record<string, string>) {
    this.auth = new Auth(host, auth, headers);
    this.suggestions = new Suggestions(host, auth, headers);
    this.imports = new Imports(host, auth, headers);
  }
}
